/**
 * AutoLISP standard library barrel — installs the pure core subset (math,
 * lists, strings, conversions). The app bridge (command, get*, entmake,
 * ssget primitives) is
 * registered separately by cadApi.ts at engine bootstrap.
 */

import type { LispRuntimeApi } from '../values';
import { NIL } from '../values';
import { define } from './internal';
import { registerMath } from './math';
import { registerList } from './list';
import { registerString } from './string';
import { registerConvert } from './convert';

export function registerStdlib(rt: LispRuntimeApi): void {
    registerMath(rt);
    registerList(rt);
    registerString(rt);
    registerConvert(rt);
    // progn evaluates every argument (the caller already did, in order) and
    // yields the last value — a plain subr is sufficient.
    define(rt, 'progn', (args) => (args.length > 0 ? args[args.length - 1] : NIL));
}
